<div class="migration__container" [class.open]="isOpen()">
  <div class="migration__content ion-padding">
    <header>
      <img src="assets/img/current-app-icon.png" alt="Current" />
      <h2>{{ 'MIGRATION.TITLE' | translate }}</h2>

      @if (isOpen()) {
        @if (canBeClosed()) {
          <ion-button (click)="close()" shape="round" size="small">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        }
      } @else {
        <ion-button (click)="isOpen.set(true)" shape="round" size="small">{{
          'MIGRATION.MOVE' | translate
        }}</ion-button>
      }
    </header>

    <section class="migration__description">
      <img src="assets/img/current-app.png" alt="Current" class="mr-3" />

      <div class="flex flex-col w-full text-sm">
        <div class="mb-auto mt-4">
          @if (canBeClosed()) {
            <h5>{{ 'MIGRATION.PHASING_OUT_TITLE' | translate }}</h5>

            <p>{{ 'MIGRATION.PHASING_OUT_MESSAGE' | translate }}</p>
          } @else {
            <h5>{{ 'MIGRATION.PHASED_OUT_TITLE' | translate }}</h5>

            <p>{{ 'MIGRATION.PHASED_OUT_MESSAGE' | translate }}</p>
          }

          @if (isTargetAppInstalled()) {
            <p>{{ (isLoggedIn() ? 'MIGRATION.OPEN_MESSAGE_LOGIN' : 'MIGRATION.OPEN_MESSAGE') | translate }}</p>
          } @else {
            <p>{{ (isLoggedIn() ? 'MIGRATION.DOWNLOAD_MESSAGE_LOGIN' : 'MIGRATION.DOWNLOAD_MESSAGE') | translate }}</p>
          }
        </div>

        <div class="pb-4">
          @if (isTargetAppInstalled()) {
            <ion-button (click)="migrateSession()" shape="round" expand="full">{{
              'MIGRATION.OPEN_CURRENT_CHARGE' | translate
            }}</ion-button>
          } @else {
            @if (isiOS) {
              <a
                href="https://apps.apple.com/no/app/current-charge/id6467710938"
                class="download-app"
                target="_blank"
                rel="noopener noreferrer">
                <img src="assets/img/download-appstore.png" />
              </a>
            } @else {
              <a
                href="https://play.google.com/store/apps/details?id=eco.current&hl=en"
                class="download-app"
                target="_blank"
                rel="noopener noreferrer">
                <img src="assets/img/download-googleplay.png" />
              </a>
            }
          }
        </div>
      </div>
    </section>
  </div>
</div>
